import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import {
  AprovadorSLDService,
  ColetorCustosService,
  EmpresaMRVService,
  FundoFixoService,
  DespesasFundoFixoService
} from 'src/app/_services';
import {
  AprovadorSLD,
  TipoDespesa,
  RateioDespesas,
  Message,
  ColetorCustos,
  EmpresaMRV,
  DivisaoEmpresa,
  FundoFixo,
  DespesasFundoFixo,
  DocumentoPreEditadoRtn
} from 'src/app/_models';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PopUpColetoresComponent } from '../popupColetores/popupColetores.component';
import { SelectionModel } from '@angular/cdk/collections';
import { ProtocoloComponent } from '../protocolo/protocolo.component';
import { PopupColetorCustosComponent } from '../popup-coletor-custos/popup-coletor-custos.component';
import { CabecalhoProtocolo, User } from '../../_models';
import { MaskService } from 'src/app/_services/mask.service';
import { DateAdapter } from '@angular/material/core';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmacaoProtocoloFundoFixoComponent } from '../confirmacaoProtocoloFundoFixo/confirmacaoProtocoloFundoFixo.component';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { UploadUCMService } from '../../_services/uploadUCM.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NaoFiscalService } from 'src/app/_services/naoFiscal.service';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';


@Component({
  selector: 'app-fundo-fixo',
  templateUrl: './fundo-fixo.component.html',
  styleUrls: ['./fundo-fixo.component.css']
})
export class FundoFixoComponent implements OnInit {
  @Input() FormDataUpload = new FormData();
  @ViewChild('resetButton', {static: true}) resetButton: ElementRef;
  currentUser: User;

  step = 0;
  constructor(
    private loadComponent: AppComponent,
    private protocoloComponent: ProtocoloComponent,
    private formBuilderFundoFixo: FormBuilder,
    private apiAprovadoresSLD: AprovadorSLDService,
    private apiColetorCustos: ColetorCustosService,
    private apiValidateEmpMRV: EmpresaMRVService,
    private apiFundoFixo: FundoFixoService,
    private apiDespesasFundoFixo: DespesasFundoFixoService,
    private dateAdapter: DateAdapter<Date>,
    private route: ActivatedRoute,
    private router: Router,
    private apiUploadUCM: UploadUCMService,
    private apiDocumentoPreEditado: DocumentoPreEditadoService,
    private apiNaoFiscal: NaoFiscalService,
    private dialog?: MatDialog,
  ) {
    this.mask = new MaskService();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.dateAdapter.setLocale('pt-br');
    this.mask = new MaskService();
  }

  // Validators
  cabecalhoFundoFixoForm: FormGroup;
  rateioDespesasFundoFixoForm: FormGroup;

  // NgModel
  rateioDespesas = {} as RateioDespesas;
  lstRateioDespesas = new Array<RateioDespesas>();
  cabecalhoProtocolo = {} as CabecalhoProtocolo;

  // API's returns
  public aprovadoresSLD: AprovadorSLD[];
  public tipoDespesas = new Array<TipoDespesa>();
  public coletoresCusto: ColetorCustos[];
  public fundoFixo: FundoFixo[];
  public fundoFixoEditar: FundoFixo[];
  public despesasfundoFixo: DespesasFundoFixo[];
  public divisoesEmpresa: DivisaoEmpresa[];

  // Models
  public tiposDespesaSelected = new DespesasFundoFixo();
  public coletoresCustoError = new Array<ColetorCustos>();
  public empresaMRV = new EmpresaMRV();
  public protocoloEdicao = new DocumentoPreEditado();
  public documentoPreEditadoRtn = new DocumentoPreEditadoRtn();

  // Screem rules
  messageModel: Message;
  somaRateio = 0.00;
  valorRateio = 0.00;
  verifingColetor = false;
  loadCNPJs = false;
  frmNomeFXEmpresa = null;
  diagramaDeRede = false;
  modoEdicao: boolean;
  confirmDocPreEditado: boolean;
  valorDivisaoFundoFixo: string;
  documentoSAP: string;
  carregandoAprovador = false;
  carregandoFundoFixo = false;
  valFundoFixo: string;
  PesColetorCustos: boolean;

  // Utilities
  mask: MaskService;

  // Controls Autocomplete
  frmFXAprovador = new FormControl();
  optionsAprovador: string[];
  filteredOptionsAprovador: Observable<string[]>;

  frmFXFundoFixo = new FormControl();
  optionsFundoFixo: string[];
  filteredOptionsFundoFixo: Observable<string[]>;

  get formFundoFixo() { return this.cabecalhoFundoFixoForm.controls; }
  get formFundoFixoRateio() { return this.rateioDespesasFundoFixoForm.controls; }

  displayedColumns = ['tipoDespesa', 'tipoColetor', 'coletorCusto', 'descricao', 'valor', 'select'];
  dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
  selection = new SelectionModel<RateioDespesas>(true, []);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  ngOnInit() {
    // fundo fixo
    this.PesColetorCustos = false;
    this.protocoloComponent.finishLoad();
    this.CarregarValidacoesTela();
    this.getAprovadoresSLD();
    this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].disable();
    this.cabecalhoFundoFixoForm.controls['frmNomeFXEmpresa'].disable();
    this.valorRateio = 0;

    const idProtocolo = this.route.snapshot.params['idProtocolo'];
    if (idProtocolo !== undefined) {
      this.modoEdicao = true;
      this.carregarDadosProtocolo(idProtocolo);
      return;
    } else {
      this.modoEdicao = false;
    }

    this.step = 1;

    if (this.protocoloComponent.tipoDocumentoForm.invalid || this.protocoloComponent.LstUploadFiles.length === 0) {
      this.protocoloComponent.fileUploadLenth = true;
    }
  }

  carregarDadosProtocolo(protocoloID: string) {
    this.apiDocumentoPreEditado.obterProtocolo(protocoloID).subscribe(
      data => this.protocoloEdicao = data.data,
      err => console.error(err),
      () => {
        if (this.protocoloEdicao !== null) {
          this.CarregarDadosTela(this.protocoloEdicao);
        }
      }
    );
  }

  CarregarDadosTela(protocolo: DocumentoPreEditado) {
    this.loadComponent.startLoading(true);
    this.cabecalhoFundoFixoForm.controls['frmFXCnpjEmpresa'].setValue(protocolo.cnpjDestinatario)
    this.cabecalhoFundoFixoForm.controls['frmFXCnpjEmpresa'].disable();
    this.valorDivisaoFundoFixo = protocolo.divisao;
    this.carregarEmpresaTomador();
    this.documentoSAP = JSON.parse(localStorage.getItem('documento'));

    this.cabecalhoProtocolo.imagens = this.protocoloComponent.cabecalhoProtocolo.imagens;
    this.lstRateioDespesas = this.protocoloComponent.lstRateioDespesas;

    this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
    this.dataSource.paginator = this.paginator;

    this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
    this.somaRateio = Number(this.somaRateio.toFixed(5));

    this.apiAprovadoresSLD.ObterAprovadores().subscribe(data => {
      this.aprovadoresSLD = data.data;
      this.cabecalhoProtocolo.aprovador = this.aprovadoresSLD.filter(x => x.login === protocolo.loginAprovador)[0].nome;
    });
  }

  CarregarValidacoesTela() {
    // VALIDAÇÕES FORMULARIO 2. FICHA DO PROTOCOLO
    this.cabecalhoFundoFixoForm = this.formBuilderFundoFixo.group({
      frmFXCnpjEmpresa: ['', Validators.nullValidator],
      frmNomeFXEmpresa: ['', Validators.required],
      frmFXAprovador: ['', Validators.required],
      frmFXFundoFixo: ['', Validators.required]
    });

    // VALIDAÇÕES FORMULARIO 3. RATEIO DE DESPESAS - FUNDO FIXO
    this.rateioDespesasFundoFixoForm = this.formBuilderFundoFixo.group({
      frmFXNumOperacao: ['', Validators.compose([Validators.required, Validators.maxLength(4)])],
      frmFXColetorCustos: ['', Validators.required],
      frmFXValorDespesa: ['', Validators.required],
      frmFXTipoDespesa: ['', Validators.required],
      frmFXTipoColetor: ['', Validators.required],
      frmFXDescricaoDespesa: ['', Validators.required],
    });
  }

  setStep(index: number) {
    const CnpjEmpresa = this.cabecalhoFundoFixoForm.controls['frmFXCnpjEmpresa'];
    let FundoFixo = this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'];
    const Aprovador = this.cabecalhoFundoFixoForm.controls['frmFXAprovador'];
    if (this.fundoFixo.filter(x => x.numNomeCaixa === FundoFixo.value).length === 0) {
      FundoFixo.setValue('');
      return;
    }

    if (this.aprovadoresSLD.filter(x => x.nome === this.cabecalhoProtocolo.aprovador).length === 0) {
      this.cabecalhoProtocolo.aprovador = '';
      return;
    }

    if (index === 2 && !this.modoEdicao && (FundoFixo.status === 'DISABLED' ||
      FundoFixo.value === '' || CnpjEmpresa.value === '' || Aprovador.value === '')) {
      return;
    } else if (index === 2) {
      this.valorRateio = +this.fundoFixo.filter(x => x.numNomeCaixa == this.formFundoFixo.frmFXFundoFixo.value)[0].saldoInicial + +this.somaRateio;
    }
    this.step = index;
  }

  nextStep() {
    const CnpjEmpresa = this.cabecalhoFundoFixoForm.controls['frmFXCnpjEmpresa'];
    let FundoFixo = this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'];
    const Aprovador = this.cabecalhoFundoFixoForm.controls['frmFXAprovador'];
    if (this.fundoFixo.filter(x => x.numNomeCaixa === FundoFixo.value).length === 0) {
      FundoFixo.setValue('');
      return;
    }

    if (this.aprovadoresSLD.filter(x => x.nome === this.cabecalhoProtocolo.aprovador).length === 0) {
      this.cabecalhoProtocolo.aprovador = '';
      return;
    }

    if (!this.modoEdicao &&
      (FundoFixo.status === 'DISABLED' || FundoFixo.value === '' || CnpjEmpresa.value === '' || Aprovador.value === '')) {
      return;
    }

    this.valorRateio = this.fundoFixo.filter(x => x.numNomeCaixa === this.formFundoFixo.frmFXFundoFixo.value)[0].saldoInicial;
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  prevStepProtocolo() {
    this.protocoloComponent.step--;
  }

  // ==================== INÍCIO COMUNICAÇÃO COM SERVICES ========================

  private _filterFundoFixo(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsFundoFixo.filter(option => option.toLowerCase().includes(filterValue));
  }

  getRetornarFundoFixo() {
    this.protocoloComponent.finishLoad();
    this.loadCNPJs = true;
    this.loadComponent.startLoading(true);
    this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].setValue(null);
    this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].disable();
    this.apiFundoFixo.GetRetornarFundoFixo(this.empresaMRV.codigoEmp)
      .subscribe(
        data => {
          this.fundoFixo = data.data;

          this.optionsFundoFixo = this.fundoFixo.map(({ numNomeCaixa }) => numNomeCaixa);
          this.filteredOptionsFundoFixo = this.frmFXFundoFixo.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filterFundoFixo(value))
            );
          this.carregandoFundoFixo = false;
        },
        err => {
          console.error(err);
          this.loadCNPJs = false;
          this.loadComponent.startLoading(false);
        },
        () => {
          this.loadCNPJs = false;
          this.loadComponent.startLoading(false);
          this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].enable();
          if (this.valorDivisaoFundoFixo !== null) {

            if (this.modoEdicao) {
              this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].disable();
            }

            if (this.modoEdicao && this.fundoFixo.filter(x => x.numCaixa === this.valorDivisaoFundoFixo).length === 0) {
              this.messageModel = new Message('Atenção', 'Seu usuário não possui acesso ao fundo fixo deste protocolo.', '', 'warning');

              const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
              dialogRef.afterClosed().subscribe(result => {
                this.router.navigate(['/home']);
              });
            } else {
              this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].setValue(this.fundoFixo.filter(x => x.numCaixa == this.valorDivisaoFundoFixo)[0].numNomeCaixa);
            }
          }
        });
  }

  getAprovadoresSLD() {
    this.carregandoAprovador = true;

    this.apiAprovadoresSLD.ObterAprovadores()
      .subscribe(
        data => {
          this.aprovadoresSLD = data.data;

          this.optionsAprovador = this.aprovadoresSLD.map(({ nome }) => nome);
          this.filteredOptionsAprovador = this.frmFXAprovador.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filterAprovador(value))
            );
          this.carregandoAprovador = false;
        });
  }

  private _filterAprovador(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsAprovador.filter(option => option.toLowerCase().includes(filterValue));
  }

  getTiposDespesas() {
    this.apiDespesasFundoFixo.GetDespesasFundoFixo(this.empresaMRV.codigoEmp).subscribe(
      data => {
        this.despesasfundoFixo = data.data;
        // preenche lista de rateios quando em modo edição
        this.lstRateioDespesas.forEach(r => {
          r.nomeTipoDespesa = this.despesasfundoFixo.filter(tpDespesa => tpDespesa.numTransacao == r.codDespesa)[0].nomeTransacao;
        });
      });
  }
  // ==================== FIM COMUNICAÇÃO COM SERVICES ============================

  ExibeMensagemUpload(title: string, message: string, status: string = null) {
    this.messageModel = new Message(title, '', `Detalhes: ${message} `, status);

    this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  incluirRateio() {
    // Validators
    if (this.rateioDespesasFundoFixoForm.invalid) { return; }

    this.rateioDespesas.identificacaoColetor = this.rateioDespesas.identificacaoColetor.toUpperCase().replace(' ', '')
    // Validate ColetoresCusto
    this.ValidarDadosRateio();
  }

  IncluirRateioDataSource() {
    // Generate rateioDespesas object
    this.tiposDespesaSelected = this.rateioDespesasFundoFixoForm.controls['frmFXTipoDespesa'].value;
    this.rateioDespesas.codDespesa = this.tiposDespesaSelected.numTransacao;
    this.rateioDespesas.nomeTipoDespesa = this.tiposDespesaSelected.nomeTransacao;
    this.rateioDespesas.contaRazao = this.tiposDespesaSelected.contaContabil;
    this.rateioDespesas.usuarioAlteracao = this.currentUser.login;
    this.rateioDespesas.usuarioCadastro = this.currentUser.login;
    this.rateioDespesas.valor = Number(this.rateioDespesas.valor.toFixed(5));
    this.PesColetorCustos = false;

    // TODO:
    this.valorRateio = this.fundoFixo.filter(x => x.numNomeCaixa === this.formFundoFixo.frmFXFundoFixo.value)[0].saldoInicial;

    if (Number(this.rateioDespesas.valor.toFixed(5)) > (+this.valorRateio - this.somaRateio)) {
      this.ExibeMensagemValorRateios();
      return;
    }

    // Add rateioDespesas object in table datasouce
    this.lstRateioDespesas.push(this.rateioDespesas);

    // TODO: 
    this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
    this.dataSource.paginator = this.paginator;

    this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);

    this.somaRateio = Number(this.somaRateio.toFixed(5));

    // CLEAR RATEIO FIELDS
    this.rateioDespesas = {} as RateioDespesas;
    this.tiposDespesaSelected = new DespesasFundoFixo();

    const btn: HTMLElement = this.resetButton.nativeElement as HTMLElement;
    btn.click();
  }

  ValidarDadosRateio() {
    if (this.VerificaCamposObrigRateio()) {
      this.verifingColetor = true;
      this.apiColetorCustos.ObterColetoresCusto(
        this.rateioDespesas.identificacaoColetor,
        this.rateioDespesas.codTipoColetor.toString(),
        this.empresaMRV.codigoEmp,
        null,
        this.formFundoFixo.frmFXFundoFixo.value,
        '01',
        this.rateioDespesas.operacaoSubNumero
      ).subscribe(
        data => this.coletoresCusto = data.data,
        err => console.error(err),
        () => {
          if (this.coletoresCusto != null) {
            this.VerificaColetoresInvalidos(this.coletoresCusto);
            this.verifingColetor = false;
          }
        }
      );
    }
  }

  VerificaColetoresInvalidos(coletores: ColetorCustos[]) {
    this.coletoresCustoError = new Array<ColetorCustos>();

    coletores.forEach(cc => {
      if (cc.status === 'E') {
        this.coletoresCustoError.push(cc);
      }
    });

    if (this.coletoresCustoError.length > 0) {
      this.dialog.open(PopUpColetoresComponent, { data: this.coletoresCustoError });
    } else {
      this.IncluirRateioDataSource();
    }
  }

  validarNumOperacao() {
    localStorage.setItem('tipoColetor', JSON.stringify(this.rateioDespesasFundoFixoForm.controls['frmFXTipoColetor'].value));

    if (this.rateioDespesasFundoFixoForm.controls['frmFXTipoColetor'].value !== 'undefined') {
      this.PesColetorCustos = true;
    } else {
      this.PesColetorCustos = false;
    }

    if (this.rateioDespesasFundoFixoForm.controls['frmFXTipoColetor'].value !== 'N') {
      this.rateioDespesasFundoFixoForm.controls['frmFXNumOperacao'].disable();
      this.rateioDespesas.operacaoSubNumero = '';
      this.diagramaDeRede = false;
    } else {
      this.rateioDespesasFundoFixoForm.controls['frmFXNumOperacao'].enable();
      this.diagramaDeRede = true;
    }
  }

  VerificaCamposObrigRateio() {
    return this.empresaMRV?.codigoEmp != null &&
      this.rateioDespesas.codTipoColetor != null &&
      this.rateioDespesas.identificacaoColetor !== '';
  }

  ExibeMensagemValorRateios() {
    this.messageModel = new Message(
      'Problema ao inserir o rateio',
      'Valor Rateio',
      'O valor do total dos rateios será maior que o valor inserido na ficha do protocolo. Tente um valor menor.',
      'warning'
    );

    this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  clearFieldsRelated() {
    this.empresaMRV = new EmpresaMRV();
    this.divisoesEmpresa = new Array<DivisaoEmpresa>();
  }

  getDivisaoByEmpresa() {
    this.apiValidateEmpMRV.ObterDivisoesEmpresaMrv(this.empresaMRV.cnpjEmp, this.empresaMRV.codFil)
      .subscribe(data => this.divisoesEmpresa = data.data);
  }

  carregarEmpresaTomador() {
    this.formFundoFixo.frmNomeFXEmpresa.setValue('');
    if (this.cabecalhoProtocolo.cnpjEmpresa !== '') {
      const re = /[.\-/]/g;
      this.cabecalhoProtocolo.cnpjEmpresa = this.cabecalhoProtocolo.cnpjEmpresa.replace(re, '');

      this.loadCNPJs = true;
      this.apiValidateEmpMRV.ObterEmpresaMrv(this.cabecalhoProtocolo.cnpjEmpresa).subscribe(
        data => { this.empresaMRV = data.data; },
        err => console.error(err),
        () => {
          if (this.empresaMRV == null) {
            this.clearFieldsRelated();
          } else {
            this.getDivisaoByEmpresa();
            this.formFundoFixo.frmNomeFXEmpresa.setValue(this.empresaMRV.descricaoEmp);
          }
          this.loadCNPJs = false;
          this.getTiposDespesas();
          this.getRetornarFundoFixo();
        }
      );
    } else {
      this.clearFieldsRelated();
    }
  }

  CarregarDadosPreEditado() {
    const docPreEditado = new DocumentoPreEditado();

    if (this.modoEdicao) {
      docPreEditado.idProtocolo = this.route.snapshot.params['idProtocolo'];
    } else {
      docPreEditado.idProtocolo = 0;
    }

    docPreEditado.valor = +this.somaRateio;
    docPreEditado.dataEmissaoNf = new Date();
    docPreEditado.dataVencimentoNf = new Date();
    docPreEditado.idTipoDocumento = Number(this.protocoloComponent.tipoDocSelected.codTipoDocumento);
    docPreEditado.descTipoDocumento = this.protocoloComponent.tipoDocSelected.tipoDocumento;
    docPreEditado.tipoDocumentoSap = this.protocoloComponent.tipoDocSelected.tipoDocumentoSap;
    docPreEditado.idStatusProtocolo = 51;
    docPreEditado.idStatusNovo = 1;
    docPreEditado.loginUsuarioCriacao = this.currentUser.login;

    docPreEditado.loginResponsavel = this.currentUser.login;
    docPreEditado.loginUsuarioResponsavel = this.currentUser.login;
    docPreEditado.emailUsuarioResponsavel = this.currentUser.email;
    if (this.modoEdicao) {
      docPreEditado.dataHoraCriacao = this.protocoloEdicao.dataHoraCriacao;
    } else {
      docPreEditado.dataHoraCriacao = new Date();
    }
    docPreEditado.dataHoraAlteracao = new Date();
    docPreEditado.loginUsuarioUltAlteracao = this.currentUser.login;
    docPreEditado.nomeFornecedor = this.formFundoFixo.frmFXFundoFixo.value;
    docPreEditado.cnpjfornecedor = '';
    docPreEditado.cpffornecedor = '';
    docPreEditado.cnpjDestinatario = this.cabecalhoProtocolo.cnpjEmpresa;
    docPreEditado.nomeEmpresa = this.cabecalhoProtocolo.nomeEmpresa;
    docPreEditado.loginAprovador = this.aprovadoresSLD.filter(x => x.nome == this.cabecalhoProtocolo.aprovador)[0].login;
    docPreEditado.observacao = '';
    docPreEditado.quantidadeRateio = this.lstRateioDespesas.length;
    docPreEditado.condicaoPagamento = '';
    docPreEditado.parcelado = false;
    docPreEditado.codDespesa = this.tiposDespesaSelected.numTransacao;
    docPreEditado.codBarras = '';
    docPreEditado.divisao = this.fundoFixo.filter(x => x.numNomeCaixa == this.formFundoFixo.frmFXFundoFixo.value)[0].numCaixa;
    docPreEditado.codEmpresa = this.empresaMRV.codigoEmp;
    docPreEditado.idSapFornecedor = '';

    if (this.documentoSAP != null && this.documentoSAP !== '') {
      docPreEditado.documento = this.documentoSAP;
    }

    docPreEditado.rateios = this.lstRateioDespesas;
    docPreEditado.adiantamentos = null;

    if (this.cabecalhoProtocolo.imagens != null && this.cabecalhoProtocolo.imagens.length > 0) {
      docPreEditado.imagensNotaFiscal = this.cabecalhoProtocolo.imagens;
    }

    return docPreEditado;
  }

  ValidacoesSalvar() {
    // Validação de campos obrigatórios
    if ((this.cabecalhoFundoFixoForm.controls['frmFXCnpjEmpresa'].value == null &&
      this.cabecalhoFundoFixoForm.controls['frmFXFundoFixo'].value == null &&
      this.cabecalhoFundoFixoForm.controls['frmFXAprovador'].value == null)
      || this.lstRateioDespesas.length === 0) {
      return false;
    }

    // Validações da validade do coletores de custo
    if (this.coletoresCustoError.length > 0) {
      this.dialog.open(PopUpColetoresComponent, { data: this.coletoresCustoError });
      return false;
    }

    return true;
  }

  CancelarProtocolo() {
    let confirmCancel = false;
    let rtn: DocumentoPreEditadoRtn;

    // Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo === 9) {
        this.messageModel = new Message('Atenção', 'Documento já cancelado, não é possível executar operação', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      if (this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4 && this.protocoloEdicao.idStatusNovo !== 7) {
        this.messageModel = new Message('Atenção', 'Não é possível realizar o cancelamento do protocolo para o status atual', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }
    }

    // Validação do perfil de movimentação de protocolos de terceiros
    if ((this.currentUser.login !== this.protocoloEdicao.loginResponsavel
      && !this.currentUser.movimentarProtocoloTerceiros)) {
      this.messageModel = new Message('Atenção', 'Não é possível realizar o cancelamento de protocolos de terceiros', '', 'warning');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return;
    }

    this.messageModel = new Message(
      'Atenção',
      'Ao confirmar a exclusão do protocolo, o mesmo será eliminado permanentemente. Deseja Continuar?',
      '',
      'confirm'
    );
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    dialogRef.afterClosed().subscribe(result => {
      confirmCancel = result;

      if (confirmCancel) {
        this.loadComponent.startLoading(true);
        this.apiDocumentoPreEditado.CancelarDocumentoFundoFixo(this.CarregarDadosPreEditado()).subscribe(
          data => {
            rtn = data.data.result;

            if (rtn?.success) {
              this.messageModel = new Message('Atenção', 'Protocolo cancelado com sucesso', '', 'success');
              this.router.navigate(['/home']);
            } else {
              this.messageModel = new Message('Atenção', rtn.message, '', 'warning');
            }

            this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
            this.loadComponent.startLoading(false);
          }
        );
      }
    });
  }

  Salvar() {
    if (!this.ValidacoesSalvar()) { return; }

    const docPreEditado = this.CarregarDadosPreEditado();

    // Validação de perfil
    if (this.currentUser.login !== docPreEditado.loginResponsavel
      && !this.currentUser.movimentarProtocoloTerceiros) {
      this.messageModel = new Message('Atenção', 'Seu usuário não possui acesso para modificação de protocolos de terceiros', '', 'warning');
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return;
    }

    // Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo === 9) {
        this.messageModel = new Message('Atenção', 'Documento já cancelado, não é possível executar operação', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      if (this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4 && this.protocoloEdicao.idStatusNovo !== 7) {
        this.messageModel = new Message('Atenção', 'Documento já aprovado, não é possível editar', '', 'warning');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }
    }

    // Confirmar gravação
    const dialogRef = this.dialog.open(ConfirmacaoProtocoloFundoFixoComponent, { data: docPreEditado });

    dialogRef.afterClosed().subscribe(result => {
      this.confirmDocPreEditado = result;

      // Verificar duplicidade na base e grava o protocolo
      if (this.confirmDocPreEditado != null && this.confirmDocPreEditado) {
        this.loadComponent.startLoading(true);
        this.VerificaDuplicidade(docPreEditado);
      }
    });
  }

  VerificaDuplicidade(docPreEditado: DocumentoPreEditado) {
    let confirmaGravacaoDuplicidade = false;
    let rtn: DocumentoPreEditadoRtn;

    this.apiNaoFiscal.VerificaDuplicidadeNaoFiscal(docPreEditado).subscribe(
      data => {
        rtn = data.data;

        if (rtn?.success) {
          this.messageModel = new Message(
            'Atenção',
            'Já existe um protocolo com esse fornecedor, valor, divisão e tipo de documento para o mês corrente. Deseja prosseguir?',
            '',
            'confirm'
          );
          const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
          dialogRef.afterClosed().subscribe(result => {
            confirmaGravacaoDuplicidade = result;
            // Caso haja a confirmação dos dados pre-editados e a confirmação de gravar em duplicidade é criado o protocolo
            if (confirmaGravacaoDuplicidade) {
              this.CriarProtocolo(docPreEditado);
            } else {
              this.loadComponent.startLoading(false);
            }
          });
        } else {
          this.CriarProtocolo(docPreEditado);
        }
      }
    );
  }

  CriarProtocolo(docPreEditado: DocumentoPreEditado) {
    this.FormDataUpload.delete('DocumentoPreEditado');
    this.FormDataUpload.append('DocumentoPreEditado', JSON.stringify(docPreEditado));

    this.protocoloComponent.FormDataUpload.delete('DocumentoPreEditado');
    this.protocoloComponent.FormDataUpload.append('DocumentoPreEditado', JSON.stringify(docPreEditado));

    if (!this.modoEdicao) {
      this.apiDocumentoPreEditado.CriarDocumentoFundoFixo(this.protocoloComponent.FormDataUpload).subscribe(
        rtn => this.documentoPreEditadoRtn = rtn.data.result,
        err => {
          this.loadComponent.startLoading(false);
          console.error(err);
        },
        () => {
          if (this.documentoPreEditadoRtn != null) {
            this.VerificaRetornoDocumento(this.documentoPreEditadoRtn);
          }
        }
      );
    } else {
      this.AtualizarProtocolo(docPreEditado);
    }
  }

  AtualizarProtocolo(documento: DocumentoPreEditado) {
    let temp;
    this.protocoloComponent.FormDataUpload.delete('DocumentoPreEditadoUpload');
    this.protocoloComponent.FormDataUpload.append('DocumentoPreEditadoUpload', JSON.stringify(documento));

    this.apiUploadUCM.upload(this.protocoloComponent.FormDataUpload).subscribe(
      rtn => temp = rtn,
      err => { console.error(err); this.loadComponent.startLoading(false); },
      () => {
        if (temp?.data?.success === false) {
          this.ExibeMensagemUpload('Erro ao enviar as imagens para o UCM. Tente novamente.', temp.data.message);
          this.loadComponent.startLoading(false);
        } else {
          this.AtualizarProtocoloIntegracoes(documento);
        }
      }
    );
  }

  AtualizarProtocoloIntegracoes(docPreEditado: DocumentoPreEditado) {
    this.FormDataUpload.delete('DocumentoPreEditado');
    this.FormDataUpload.append('DocumentoPreEditado', JSON.stringify(docPreEditado));

    this.protocoloComponent.FormDataUpload.delete('DocumentoPreEditado');
    this.protocoloComponent.FormDataUpload.append('DocumentoPreEditado', JSON.stringify(docPreEditado));

    this.apiDocumentoPreEditado.AtualizarDocumentoFundoFixo(this.protocoloComponent.FormDataUpload).subscribe(
      rtn => this.documentoPreEditadoRtn = rtn.data.result,
      err => {
        this.loadComponent.startLoading(false);
        this.messageModel = new Message('Erro ao editar', err, '', 'error');
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        console.error(err);
      },
      () => {
        if (this.documentoPreEditadoRtn?.success) {
          this.loadComponent.startLoading(false);
          this.ExibeMensagemSucessoProtocolo(this.documentoPreEditadoRtn.data.idProtocolo, this.documentoPreEditadoRtn.data.documento);
        } else {
          this.messageModel = new Message(
            'Ocorreu um problema ao criar o documento pré-editado no SAP',
            this.documentoPreEditadoRtn.message,
            '',
            'error'
          );

          this.loadComponent.startLoading(false);
          this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        }
        this.loadComponent.startLoading(false);
      }
    );
  }

  VerificaRetornoDocumento(documento: DocumentoPreEditadoRtn) {
    this.loadComponent.startLoading(true);
    if (documento.success) {
      const docPreEditado = this.CarregarDadosPreEditado();
      docPreEditado.idProtocolo = documento.data.idProtocolo;
      if (!this.modoEdicao) {
        docPreEditado.documento = documento.data.documento;
        this.documentoSAP = documento.data.documento;
      }

      this.uploadFiles(docPreEditado);
    } else {
      this.messageModel = new Message(
        'Ocorreu um problema ao criar o documento pré-editado no SAP',
        documento.message,
        '',
        'error'
      );

      this.loadComponent.startLoading(false);
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    }
  }

  uploadFiles(documento: DocumentoPreEditado) {
    let temp;
    this.protocoloComponent.FormDataUpload.delete('DocumentoPreEditadoUpload');
    this.protocoloComponent.FormDataUpload.append('DocumentoPreEditadoUpload', JSON.stringify(documento));

    this.apiUploadUCM.upload(this.protocoloComponent.FormDataUpload).subscribe(
      rtn => temp = rtn,
      err => { console.error(err); this.loadComponent.startLoading(false); },
      () => {
        if (temp?.data?.success === false) {
          this.ExibeMensagemUpload('Erro ao enviar as imagens para o UCM. Tente novamente.', temp.data.message);
        } else {
          this.ExibeMensagemSucessoProtocolo(documento.idProtocolo, documento.documento);
        }
        this.loadComponent.startLoading(false);
      }
    );
  }

  ExibeMensagemSucessoProtocolo(idProtocolo: number, documento: string) {
    const title = 'Item processado com sucesso';
    const message = `N° Protocolo: ${idProtocolo} - N° Pedido Não Fiscal: ${documento}`;
    this.messageModel = new Message(title, '', `Detalhes: ${message} `, 'success');
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    dialogRef.afterClosed().subscribe(r => {
      this.router.navigate(['/home']);
    });
  }

  deleteRow(row) {
    if (this.modoEdicao && !this.currentUser.movimentarProtocoloTerceiros &&
      this.protocoloEdicao.loginResponsavel !== this.currentUser.login ||
      (this.modoEdicao && this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4)) {
      return;
    }

    this.messageModel = new Message(
      'Rateios',
      'Confirma a exclusão do item?',
      '',
      'confirm'
    );

    let confirmDeleteRateio = false;
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

    dialogRef.afterClosed().subscribe(result => {
      confirmDeleteRateio = result;
      if (confirmDeleteRateio != null && confirmDeleteRateio) {
        const index = this.lstRateioDespesas.findIndex(d => d.identificacaoColetor === row.identificacaoColetor);
        this.lstRateioDespesas.splice(index, 1);

        this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
        this.somaRateio = this.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
      }
    });
  }

  deleteAllRows() {
    if (this.modoEdicao && !this.currentUser.movimentarProtocoloTerceiros &&
      this.protocoloEdicao.loginResponsavel !== this.currentUser.login ||
      (this.modoEdicao && this.protocoloEdicao.idStatusNovo !== 1 && this.protocoloEdicao.idStatusNovo !== 4)) {
      return;
    }

    this.messageModel = new Message(
      'Rateios',
      'Confirma a exclusão de todos os itens de rateio?',
      '',
      'confirm'
    );

    let confirmDeleteRateio = false;
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });

    dialogRef.afterClosed().subscribe(result => {
      confirmDeleteRateio = result;
      if (confirmDeleteRateio != null && confirmDeleteRateio) {
        this.lstRateioDespesas = new Array<RateioDespesas>()
        this.dataSource = new MatTableDataSource<RateioDespesas>(this.lstRateioDespesas);
        this.valorRateio = this.fundoFixo.filter(x => x.numNomeCaixa === this.formFundoFixo.frmFXFundoFixo.value)[0].saldoInicial;
        this.somaRateio = 0.00;
      }
    });
  }

  getErrorMessageNumOperacao() {
    if (this.formFundoFixoRateio.frmFXNumOperacao.hasError('maxlength')) {
      return 'O número da operação deve possuir no máximo 4 caracteres.';
    } else {
      return 'Numero da operação é obrigatório quando o tipo de coletor é igual a Diagrama de Rede';
    }
  }

  PesquisarColetorCustos() {
    let confirmacaoTermo: string;

    const dialogRef = this.dialog.open(PopupColetorCustosComponent);
    dialogRef.afterClosed().subscribe(result => {
      confirmacaoTermo = result;
      if (confirmacaoTermo !== '') {
        this.rateioDespesas.identificacaoColetor = confirmacaoTermo;
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}